import type { RouteConfig } from 'vue-router';
import { Role } from '@/modules/shared/types';

const route: RouteConfig = {
    path: '/:customer/customers',
    name: 'admin-customers',
    component: () => import(/* webpackChunkName: "ctx-admin-customers" */ './CustomersView.vue'),
    meta: {
        role: Role.APP_ADMIN,
        license: [],
        authenticated: true,
        settingsTabs: true,
        settingsTabsGroup: 'company-admin',
        portfolioTabs: false,
        navbar: true,
        footer: true,
        onboarding: true,
        notifications: true,
    },
};

export { route };
